import React, { useState, useEffect } from 'react'
import { styled } from '@mui/system';
import { useNavigate, useLocation } from "react-router-dom";
import NavBar from '../NavBar/NavBar';
import StudentDetails from './StudentDetails';
import AddActivity from '../Activity/AddActivity';
import FullPageLoader from '../FullPageLoader/FullPageLoader';
import { auth, db } from '../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { set, ref, get } from 'firebase/database';
import { getUserData, getUserDetails, getCollegeName } from '../HomePage/userManagement';
import EmailAvatar from '../HomePage/EmailAvatar';
import ActivityInstruction from '../Activity/ActivityInstruction';
// import BehaviouralAnalysis from '../Behavioural/BehaviouralAnalysis';
// import BehaviouralInput from '../Behavioural/BehaviouralInput';
import { useDispatch } from 'react-redux';
import { setUserName, setCollegeName, setCounts } from './userDetailsSlice';


const MainContainer = styled('div')({
    height: "100vh",
    display: 'flex',
    flexDirection: 'row',
});
const FirstHalf = styled('div')({
    width: '20%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRight: '2.5px solid #D8D0D0',
    borderBottom: '2.5px solid #D8D0D0',
    background: '#fafafa',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
});
const ContentHalf = styled('div')({
    flex: 1,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    overflowY: 'auto'
});

// const dateStamp = new Date().toString();

const UserDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = React.useState(location.state?.activeTab || 0);
    const currentRoute = location.pathname;
    const [isLoading, setIsLoading] = useState(true);
    const [name, setName] = useState('');
    const [studentDetailsData, setStudentDetailsData] = React.useState({
        hometown: '',
        targetJobRole: '',
        expyears: '',
        education: '',
        gender: '',
        otherIndustries: '',
    });
    const [industryChecked, setIndustryChecked] = React.useState({
        IT: false,
        Finance: false,
        Engineering: false,
        Healthcare: false,
        Retail: false,
        Other: false,
    });
    const [activityData, setActivityData] = React.useState([]);
    // const [behaviouralData, setbehaviouralData] = React.useState([]);
    const [user, setUser] = useState(null);
    const [validationError, setValidationError] = React.useState(null);

    useEffect(() => {
        const loadingTimer = setTimeout(() => {
            setIsLoading(false);
        }, 1000);

        return () => clearTimeout(loadingTimer);
    }, []);

    useEffect(() => {
        const updatedCounts = {
            countT: 0,
            countI: 0,
            countTI: 0,
            countEp: 0,
            countEn: 0,
            countAcademic: 0,
            countCorporate: 0,
        };

        Object.values(activityData).forEach((act) => {
            if (act.activityType === 3) {
                updatedCounts.countT++;
            } else if (act.activityType === 1) {
                updatedCounts.countI++;
            } else if (act.activityType === 2) {
                updatedCounts.countTI++;
            }
            if (act.enjoyment === 2) {
                updatedCounts.countEp++;
            } else if (act.enjoyment === 0) {
                updatedCounts.countEn++;
            }
            if (act.participationType === 'Academic') {
                updatedCounts.countAcademic++;
            } else if (act.participationType === 'Institutional/ Public') {
                updatedCounts.countCorporate++;
            }
        });

        dispatch(setCounts(updatedCounts));
    }, [activityData, dispatch]);

    useEffect(() => {
        dispatch(setUserName(name));
    }, [name, dispatch]);

    useEffect(() => {
        dispatch(setCollegeName(getCollegeName()));
    }, [dispatch]);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
            if (authUser) {
                setUser(authUser);
                try {
                    const userUid = authUser.uid;
                    const studentDetailsRef = ref(db, `${getCollegeName()}/New_Users/${userUid}`);
                    const activityDetailsRef = ref(db, `${getCollegeName()}/Activities/${userUid}`);

                    const [studentSnapshot, activitySnapshot] = await Promise.all([get(studentDetailsRef), get(activityDetailsRef)]);
                    const studentDetailsFromDb = studentSnapshot.val();
                    const activityDetailsFromDb = activitySnapshot.val();

                    if (studentDetailsFromDb) {
                        setStudentDetailsData(studentDetailsFromDb);
                    }
                    if (activityDetailsFromDb) {
                        setActivityData(activityDetailsFromDb);
                    }
                } catch (error) {
                    console.error('Error fetching user details from the database:', error);
                }
            } else {
                setUser(null);
                navigate('/login');
            }
        });

        return () => unsubscribe();
    }, [navigate]);


    const handleNext = () => {
        setActiveTab((prevTab) => prevTab + 1);
    };

    const handleIndustryChange = (event) => {
        const { name, checked } = event.target;
        setIndustryChecked((prevChecked) => ({
            ...prevChecked,
            [name]: checked,
        }));
    };

    const handleNextClick = async () => {
        let emptyFields = [];

        switch (activeTab) {
            case 0:
                emptyFields = ['hometown', 'targetJobRole', 'expyears', 'education', 'gender']
                    .filter(field => !studentDetailsData[field]);
                if (name.length < 2) {
                    emptyFields.push("First Name");
                }
                break;
            case 2:
                const activityCount = activityData && typeof activityData === 'object'
                    ? Object.keys(activityData).length
                    : 0;
                if (activityCount < 3) {
                    emptyFields.push("At least 3 or more activities required.");
                }
                if (['hometown', 'targetJobRole', 'expyears', 'education', 'gender']
                    .some(field => !studentDetailsData[field])) {
                    emptyFields.push("student details");
                }
                break;
            default:
                break;
        }

        if (emptyFields.length > 0) {
            const missingFields = emptyFields.join(', ');
            setValidationError(`Please fill out all fields in ${missingFields}.`);
            setTimeout(() => {
                setValidationError(null);
            }, 3000);
        } else {
            setValidationError(null);
            if (activeTab === 2) {
                try {
                    const userUid = user.uid;
                    const userRef = ref(db, `${getCollegeName()}/New_Users/${userUid}`);
                    const activitiesRef = ref(db, `${getCollegeName()}/Activities/${userUid}`);
                    const activitiesData = {};
                    await set(userRef, {
                        userId: userUid,
                        hometown: studentDetailsData.hometown,
                        targetJobRole: studentDetailsData.targetJobRole,
                        expyears: studentDetailsData.expyears,
                        education: studentDetailsData.education,
                        gender: studentDetailsData.gender,
                        otherIndustries: studentDetailsData.otherIndustries,
                        isConsent: true,
                    });
                    Object.values(activityData).forEach((activity, index) => {
                        const weight = ((activity.highestLevel * 10) + activity.outcome) * (1 + (activity.enjoyment));
                        const activityId = `activityId${index + 1}`;
                        activitiesData[activityId] = {
                            activity: activity.activity,
                            activityType: activity.activityType,
                            enjoyment: activity.enjoyment,
                            highestLevel: activity.highestLevel,
                            outcome: activity.outcome,
                            participationType: activity.participationType,
                            weights: weight,
                        };
                    });
                    const otherIndustriesRefs = ref(db, `${getCollegeName()}/OtherIndustries/${userUid}`);
                    await set(otherIndustriesRefs, industryChecked);
                    await set(activitiesRef, activitiesData);
                    navigate('/landingpage');
                } catch (error) {
                    console.error('Error writing student details to the database:', error);
                }
            } else {
                handleNext();
            }
        }
    };

    const routePaths = [
        '/dashboard',
        '/userdetails',
        '/quetionairepart1',
        '/report',
    ];
    const activePageIndex = routePaths.indexOf(currentRoute);
    const handlePrevious = () => {
        setActiveTab((prevTab) => prevTab - 1);
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case 0:
                return getUserDetails ? (
                    <StudentDetails
                        data={studentDetailsData}
                        setData={setStudentDetailsData}
                        userData={getUserData}
                        userDetails={getUserDetails}
                        industryChecked={industryChecked}
                        handleIndustryChange={handleIndustryChange}
                        handleNextClick={handleNextClick}
                        validationError={validationError}
                        name={name}
                        setName={setName}
                    />
                ) : (
                    <StudentDetails data={studentDetailsData} setData={setStudentDetailsData} userData={getUserData}
                        industryChecked={industryChecked}
                        handleIndustryChange={handleIndustryChange}
                        handleNextClick={handleNextClick}
                        validationError={validationError}
                        name={name}
                        setName={setName}
                    />
                );
            // case 1:
            //     return <BehaviouralInput handlePrevious={handlePrevious} handleNextClick={handleNextClick} />;
            // case 2:
            //     return <BehaviouralAnalysis data={behaviouralData} setData={setbehaviouralData} handlePrevious={handlePrevious} handleNextClick={handleNextClick} validationError={validationError} />;
            case 1:
                return <ActivityInstruction handlePrevious={handlePrevious} handleNextClick={handleNextClick} />;
            case 2:
                return <AddActivity data={activityData} setData={setActivityData} handlePrevious={handlePrevious} handleNextClick={handleNextClick} validationError={validationError} />;
            default:
                return null;
        }
    };

    return (
        <MainContainer>
            {isLoading && <FullPageLoader />}
            <FirstHalf >
                <NavBar activePage={activePageIndex} user={getUserDetails} />
            </FirstHalf>
            <ContentHalf>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexDirection: 'row-reverse', padding: '7px', width: '90%' }}>
                    <EmailAvatar />
                </div>
                {renderTabContent()}
            </ContentHalf>
        </MainContainer>
    )
}

export default UserDetails;